import { CostumeID, CostumeRegistry, CostumeSet } from "./Costume";

const Separator = "-";

export function encodeCostumes(costumes: CostumeSet): string {
  return Array.from(costumes.values()).sort().map(String).join(Separator);
}

export function decodeCostumes(
  costumeRegistry: CostumeRegistry,
  encodedCostumes: string
): CostumeSet {
  const costumes = new Set<CostumeID>();

  for (const encodedCostume of encodedCostumes.split(Separator)) {
    const costume = Number(encodedCostume) as CostumeID;

    if (!costumeRegistry[costume]) {
      continue;
    }

    costumes.add(costume);
  }

  return costumes;
}
